__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ca-cp-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@securitize/reactjs-cp-ui", "0.12.0", () => (Promise.all([__webpack_require__.e(673), __webpack_require__.e(171), __webpack_require__.e(405), __webpack_require__.e(710), __webpack_require__.e(111), __webpack_require__.e(334), __webpack_require__.e(897)]).then(() => (() => (__webpack_require__(6171))))));
			register("@securitize/reactjs-sid-utils", "0.5.3", () => (Promise.all([__webpack_require__.e(438), __webpack_require__.e(469)]).then(() => (() => (__webpack_require__(3850))))));
			register("axios", "1.7.7", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(4344))))));
			register("history", "5.3.0", () => (__webpack_require__.e(296).then(() => (() => (__webpack_require__(5296))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(1880))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(7950))))));
			register("react", "17.0.2", () => (__webpack_require__.e(664).then(() => (() => (__webpack_require__(2664))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};